// extracted by mini-css-extract-plugin
export const eventImageContainer = "featured-event-module--eventImageContainer--5Clmu";
export const eventImage = "featured-event-module--eventImage--174vL";
export const eventImageDetails = "featured-event-module--eventImageDetails--1ibt1";
export const eventImageActions = "featured-event-module--eventImageActions--NCWgG";
export const eventImageDate = "featured-event-module--eventImageDate--1wkSk";
export const eventImageDateContainer = "featured-event-module--eventImageDateContainer--lv3rE";
export const eventSummary = "featured-event-module--eventSummary--uWA19";